import { render, staticRenderFns } from "./room-info.vue?vue&type=template&id=5e8e19e9&scoped=true&"
import script from "./room-info.vue?vue&type=script&lang=js&"
export * from "./room-info.vue?vue&type=script&lang=js&"
import style0 from "./room-info.vue?vue&type=style&index=0&id=5e8e19e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8e19e9",
  null
  
)

export default component.exports